import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.63604 2.63604C4.32387 0.948212 6.61305 0 9 0C11.3869 0 13.6761 0.948212 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9C18 10.1819 17.7672 11.3522 17.3149 12.4442C16.8626 13.5361 16.1997 14.5282 15.364 15.364C14.5282 16.1997 13.5361 16.8626 12.4442 17.3149C11.3522 17.7672 10.1819 18 9 18C7.8181 18 6.64778 17.7672 5.55585 17.3149C4.46392 16.8626 3.47177 16.1997 2.63604 15.364C1.80031 14.5282 1.13738 13.5361 0.685084 12.4442C0.232792 11.3522 0 10.1819 0 9C5.36442e-08 6.61305 0.948211 4.32387 2.63604 2.63604ZM9 4.5C9.49706 4.5 9.9 4.90294 9.9 5.4V9C9.9 9.49706 9.49706 9.9 9 9.9C8.50294 9.9 8.1 9.49706 8.1 9V5.4C8.1 4.90294 8.50294 4.5 9 4.5ZM8.1 12.6C8.1 12.1029 8.50294 11.7 9 11.7H9.009C9.50606 11.7 9.909 12.1029 9.909 12.6C9.909 13.0971 9.50606 13.5 9.009 13.5H9C8.50294 13.5 8.1 13.0971 8.1 12.6Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.fill)
    ? (_openBlock(), _createBlock("svg", _hoisted_1, [
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
}